import { makeStyles } from "@material-ui/core";
import AppBar from "@material-ui/core/AppBar";
import Button from "@material-ui/core/Button";
import CircularProgress from "@material-ui/core/CircularProgress";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import IconButton from "@material-ui/core/IconButton";
import Toolbar from "@material-ui/core/Toolbar";
import Typography from "@material-ui/core/Typography";
import CancelIcon from "@material-ui/icons/Cancel";
import CloseIcon from "@material-ui/icons/Close";
import SaveIcon from "@material-ui/icons/Save";
import axios from "axios";
import _ from "lodash";
import React, { useCallback, useEffect, useState } from "react";
import { BootstrapTable, TableHeaderColumn } from "react-bootstrap-table";
import "./eventsPerLeagueList.css"; 
import Loader from "../../components/common/loader/Loader";

function EventsPerLeagueList(props) {
  const useStyles = makeStyles((theme) => ({
    root: {
      width: "100%",
    },
    appBar: {
      position: "relative",
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
    title: {
      marginLeft: theme.spacing(2),
      flex: 1,
    },
    button: {
      margin: theme.spacing(1),
    },

    center: {
      margin: "0 auto",
      border: "1px grey black",
      textAlign: "center",
      width: "50%",
      "& .MuiTextField-root": {
        margin: theme.spacing(1),
        width: 200,
      },
      "& .MuiFormGroup-row": {
        justifyContent: "center",
      },
      "& .MuiFormControl-root": {
        justifyContent: "center",
      },
    },
  }));

  const classes = useStyles();

  const [open, setOpen] = React.useState(true);
  const [loading, setLoading] = React.useState(true);
  const [isLoading, setIsLoading] = useState(false);
  const [eventsLeagues, setEventsLeagues] = useState([]);
  const [eventsSelected, setEventsSelected] = React.useState([]);

  const getEvents = useCallback(() => {
    const url = `${process.env.REACT_APP_API2_URL}/Events/GetEventsByLeague2?idLeague=${props.IdLeague}`;
    axios
      .get(url)
      .then((response) => response.data)
      .then((data) => {
        let events = _.groupBy(data, "IdEvent");
        events = _.map(events, (eventDetails) => _.head(eventDetails));
        events = _.orderBy(events, ["EventOrder"], ["asc"]);

        setLoading(false);
        setEventsLeagues(events);
      });
  }, [props.IdLeague]);

  useEffect(() => {
    getEvents();
  }, [getEvents]);

  const handleClose = () => {
    if (props.onClose) {
      props.onClose();
    }
    setOpen(false);
  };

  function onSelectAll(isSelected, rows) {
    if (isSelected) {
      setEventsSelected(rows.map((row) => row.idEvent));
    } else {
      setEventsSelected([]);
    }
  }

  function onRowSelect(row, isSelected) {
    if (isSelected) {
      setEventsSelected((currentEvents) => currentEvents.concat(row.idEvent));
    } else {
      setEventsSelected((currentEvents) =>
        currentEvents.filter((item) => item.IdEvent !== row.idEvent)
      );
    }
  }

  const selectRowProp = {
    mode: "checkbox",
    clickToSelect: true,
    onSelect: onRowSelect,
    onSelectAll: onSelectAll,
  };

  const insertEvents = useCallback(() => {
    setIsLoading(true);
    let games = [];
    Promise.all(
      props.IdGames.map((idGame) => {
        games.push(idGame);
      })
    ).then((results) => {
        callApi(games, 0);


      if (results.every((result) => result === 1)) {
        props.clearArray();
        props.searchGameValues();
        setIsLoading(true);
        handleClose();
      }
    });


  }, [handleClose, eventsSelected, props]);

  const callApi = (games, i) => { 
    const url = process.env.REACT_APP_API2_URL + "/Events/InsertGameEvents";
    return  axios
      .post(url, {
        IdGame: games[i],
        IdEvents: eventsSelected,
      })
      .then((response) => {
       response.data
        if (response.data === 0) {
          props.searchGameValues();
          setIsLoading(true);
          handleClose();
        }

        if (i + 1 < games.length) { 
          callApi(games, i + 1)
        }
      })
    .catch(error => console.log(error))
  }


  const options = {
    beforeShowError: (type, msg) => {
      this.setState({ errType: type, errMsg: msg });
      // return false or do not return will not trigger the toastr,
      // if you want the toastr popup, you should return true always.
    },
  };

  const printList = () => {
    return (
      <Dialog style={{ maxWidth: "75%" }} open={open} onClose={handleClose}>
        <AppBar className={classes.appBar}>
          <Toolbar>
            <IconButton
              edge="start"
              color="inherit"
              onClick={handleClose}
              aria-label="close"
            >
              <CloseIcon />
            </IconButton>
            <Typography variant="h6" className={classes.title}>
              Events
            </Typography>
          </Toolbar>
        </AppBar>
        {loading ? (
          <CircularProgress style={{ margin: "0 auto" }} />
        ) : (
            <React.Fragment>
              <br />
              {eventsLeagues && (
                <div style={{ width: 450, margin: "0 auto" }}>
                  <BootstrapTable
                    data={eventsLeagues}
                    selectRow={selectRowProp}
                    options={options}
                  >
                    <TableHeaderColumn
                      visible="none"
                      isKey={true}
                      hidden
                      hiddenOnInsert
                      dataField="idEvent"
                    >
                      ID
                  </TableHeaderColumn>
                    <TableHeaderColumn dataField="description">
                      Events:
                  </TableHeaderColumn>
                  </BootstrapTable>
                </div>
              )}
            </React.Fragment>
          )}
        <DialogActions>
          {isLoading ? (
            <Loader height={100} width={100}></Loader>
          ) : (
              <div>
                <Button
                  startIcon={<SaveIcon />}
                  variant="contained"
                  color="primary"
                  onClick={insertEvents}
                >
                  Ok
                </Button>
                <Button startIcon={<CancelIcon />} onClick={handleClose}>
                  Cancel
                </Button>
              </div>
            )}
        </DialogActions>
      </Dialog>
    );
  };

  return printList();
}

export default EventsPerLeagueList;
